var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanknoteArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 15H3.33366C2.89163 15 2.46771 14.8244 2.15515 14.5118C1.84259 14.1993 1.66699 13.7754 1.66699 13.3333V6.66667C1.66699 6.22464 1.84259 5.80072 2.15515 5.48816C2.46771 5.17559 2.89163 5 3.33366 5H16.667C17.109 5 17.5329 5.17559 17.8455 5.48816C18.1581 5.80072 18.3337 6.22464 18.3337 6.66667V10.8333M15.0003 10H15.0087M15.8337 18.3333V13.3333M15.8337 13.3333L18.3337 15.8333M15.8337 13.3333L13.3337 15.8333M5.00033 10H5.00866M11.667 10C11.667 10.9205 10.9208 11.6667 10.0003 11.6667C9.07985 11.6667 8.33366 10.9205 8.33366 10C8.33366 9.07953 9.07985 8.33333 10.0003 8.33333C10.9208 8.33333 11.667 9.07953 11.667 10Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknoteArrowUp);
export default __webpack_public_path__ + "static/media/banknote-arrow-up.317511e4250ab7b589cf1ad4aa55d524.svg";
export { ForwardRef as ReactComponent };